var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4258_51666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85705 9.68667V3.93333C8.85705 3.15536 8.55604 2.40926 8.02023 1.85915C7.48441 1.30905 6.7577 1 5.99994 1C5.24219 1 4.51547 1.30905 3.97966 1.85915C3.44385 2.40926 3.14283 3.15536 3.14283 3.93333V9.68667C2.48999 10.1606 1.95555 10.7864 1.58315 11.5128C1.21075 12.2393 1.01093 13.0458 1 13.8667C1 15.2281 1.52678 16.5338 2.46445 17.4965C3.40212 18.4592 4.67388 19 5.99994 19C7.32601 19 8.59777 18.4592 9.53544 17.4965C10.4731 16.5338 10.9999 15.2281 10.9999 13.8667C11.0053 13.0427 10.8126 12.2301 10.4388 11.5009C10.065 10.7717 9.52169 10.1486 8.85705 9.68667Z",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16C7.10457 16 8 15.1046 8 14C8 12.8954 7.10457 12 6 12C4.89543 12 4 12.8954 4 14C4 15.1046 4.89543 16 6 16Z",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12V9.5",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10L16 3M16 3L13 6M16 3L19 6",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4258_51666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempHigh);
export default __webpack_public_path__ + "static/media/tempHigh.2d21f4162226b9057547202005f1e920.svg";
export { ForwardRef as ReactComponent };